import { Component, Input, output } from '@angular/core'
import { IBvUser } from '@ziptility/modules'
import { FormsModule } from '@angular/forms'
import { MentionDirective } from './bv-mention.directive'

@Component({
  selector: 'bv-mention-input',
  template: `
    <div class="flex items-center space-x-5 justify-between border-t border-gray-200 p-2 pr-5">
      <textarea
        class="form-input overflow-y-scroll w-full"
        placeholder="Add a note"
        [(ngModel)]="message"
        (ngModelChange)="onMessageUpdate($event)"
        [mention]="users"
        [mentionConfig]="mentionConfig"
      ></textarea>
      <button class="bv-button" [disabled]="disabled" (click)="onSubmit.emit()">Add</button>
    </div>
  `,
  imports: [FormsModule, MentionDirective],
})
export class BvMentionInputComponent {
  mentions: IBvUser[] = []

  @Input()
  message: string

  @Input()
  users: IBvUser[]

  readonly onMessageChange = output<{
    message: string;
    mentions: IBvUser[];
}>();

  readonly onSubmit = output<void>();

  onMessageUpdate(message) {
    const { mentions } = this
    this.onMessageChange.emit({
      message,
      mentions,
    })
  }

  get disabled() {
    return !this.message
  }

  get mentionConfig() {
    return {
      labelKey: 'fullName',
      mentionSelect: (user) => {
        if (!this.mentions.includes(user)) {
          this.mentions.push(user)
        }
        return `@${user.fullName}`
      },
    }
  }
}
